import React from "react";
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from "react-icons/fa";

const AboutPage = () => {
  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        padding: "20px",
        maxWidth: "800px",
        margin: "auto",
      }}
    >
      <h1 style={{ textAlign: "center", color: "#007BFF", fontSize: 38 }}>
        About Us
      </h1>
      <p>
        Welcome to <strong>Blue Washer</strong>, your trusted partner for
        premium vehicle cleaning services. We bring convenience, quality, and
        eco-friendliness right to your doorstep. Our mission is to redefine
        vehicle care, ensuring your car or bike always looks its best while
        preserving the environment.
      </p>

      <h2 className="pt-4 font-bold">Why Choose Blue Washer?</h2>
      <p>
        At Blue Washer, we pride ourselves on delivering exceptional service
        tailored to your needs. Here’s what sets us apart:
      </p>
      <ul style={{ lineHeight: "1.8", paddingLeft: "20px" }}>
        <li className="pt-4 ">
          <strong>Comprehensive Services:</strong> From a quick wash to detailed
          cleaning, we offer Premium Car Wash, Standard Car Wash, Basic Car
          Wash, Premium Bike Wash, and Standard Bike Wash.
        </li>
        <li className="pt-4 ">
          <strong>Skilled Professionals:</strong> Our trained team ensures a
          spotless finish every time, with attention to detail and precision.
        </li>
        <li className="pt-4 ">
          <strong>Convenience:</strong> Book online, and we’ll handle the rest.
          Enjoy hassle-free vehicle care at your location.
        </li>
      </ul>

      <h2 className="pt-4 font-bold">Our Services</h2>
      <p>
        We offer a variety of services to cater to all your vehicle cleaning
        needs:
      </p>
      <ul style={{ lineHeight: "1.8", paddingLeft: "20px" }}>
        <li>
          <strong>Premium Car Wash:</strong> A thorough cleaning service for the
          ultimate shine.
        </li>
        <li>
          <strong>Standard Car Wash:</strong> Perfect for regular maintenance.
        </li>
        <li>
          <strong>Basic Car Wash:</strong> A quick and efficient cleaning
          solution.
        </li>
        <li>
          <strong>Premium Bike Wash:</strong> Detailed cleaning for your
          two-wheeler.
        </li>
        <li>
          <strong>Standard Bike Wash:</strong> A practical option for everyday
          upkeep.
        </li>
      </ul>

      <h2 className="pt-4 font-bold">Our Commitment</h2>
      <p>
        At Blue Washer, customer satisfaction is our top priority. We strive to
        exceed expectations by combining advanced cleaning techniques with a
        customer-first approach. Our dedication to quality and sustainability
        ensures you receive the best service while contributing to a cleaner,
        greener future.
      </p>

      <h3
        style={{ textAlign: "center", marginTop: "30px", fontWeight: "bold" }}
      >
        Follow Us
      </h3>
      <p style={{ textAlign: "center" }}>
        Stay connected with us on social media for updates, tips, and special
        offers:
      </p>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "15px",
          marginTop: "10px",
        }}
      >
        <a
          href="https://facebook.com"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Facebook"
        >
          <FaFacebook size={30} color="#4267B2" />
        </a>
        <a
          href="https://twitter.com"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Twitter"
        >
          <FaTwitter size={30} color="#1DA1F2" />
        </a>
        <a
          href="https://instagram.com"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Instagram"
        >
          <FaInstagram size={30} color="#C13584" />
        </a>
        <a
          href="https://linkedin.com"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="LinkedIn"
        >
          <FaLinkedin size={30} color="#0077B5" />
        </a>
      </div>
    </div>
  );
};

export default AboutPage;
